var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

var $ = require("jquery");

window.jQuery = $;
window.$ = $;



/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/Init.js
 ** module id = 0
 ** module chunks = 1
 **/